/*🤫
🤫
🤫
🤫
🤫
🤫*/

/*🤫*/
/*🤫*/
window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

(function (win) {
  try {
    /*🤫*/
    win.exactag = win.exactag || {};
    win.lhotse = win.lhotse || {};
    win.lhotse.exactag = win.lhotse.exactag || {};

    /*🤫*/
    const loc = win.location;
    const consentPartnerMap = {
      39: "xad", /*🤫*/
      40: "xaa", /*🤫*/
      44: "xta", /*🤫*/
      755: "xgr", /*🤫*/
      759: "xrj", /*🤫*/
    };

    /*🤫*/
    window.o_util.core.extend(win.lhotse.exactag, {
      version: "0.8.7",
      /*🤫*/
      debug:
        loc.href.indexOf("#debug") > -1 ||
        window.o_util.cookie.get("debug") === "true",
      /*🤫*/
      benchmark:
        loc.href.indexOf("#benchmark") > -1 ||
        window.o_util.cookie.get("PartnerPixelBenchmark") ===
        "PixelBenchmark=true",
      /*🤫*/
      OptOutMode: false,
      /*🤫*/
      trackingOptOutMode: false,
      /*🤫*/
      testMode: false,
      /*🤫*/
      QAMode: false,
      /*🤫*/
      campaignId: "ffaacb82c52393300a9d3b3376091c43",
      /*🤫*/
      baseParams: [
        "campaign",
        "pt",
        "uu",
        "ls",
        "hc",
        "cs",
        "ag",
        "pz",
        "ka",
        "bp",
        "sf",
        "cb",
        "xo",
        ...Object.entries(consentPartnerMap).map(([, v]) => v),
      ],
      consentPartnerMap,
      data: {},
      fns: {},
      first: true,

      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      /*🤫*/
      register(triggerID, fn) {
        win.lhotse.exactag.fns[triggerID] = fn;
      },

      /*🤫*/
      addCampaignId() {
        win.lhotse.exactag.data.campaign = win.lhotse.exactag.campaignId;

        return win.lhotse.exactag.data;
      },

      getCookieParameter() {
        /*🤫*/
        const cbCookie = window.o_util.cookie.get("cb");
        return cbCookie === "1" || cbCookie === "2" ? "1" : "0";
      },

      /*🤫*/
      addGenericData() {
        /*🤫*/
        win.lhotse.exactag.data.uu =
          window.o_util.cookie.get("BrowserId") || "";

        /*🤫*/
        win.lhotse.exactag.data.sp = loc.pathname.split(/\?|#/)[0].substring(1);

        /*🤫*/
        win.lhotse.exactag.data.pt = "Default";

        /*🤫*/
        if (
          !!window.o_global.device &&
          !!window.o_global.device.breakpoint &&
          typeof window.o_global.device.breakpoint.getCurrentBreakpoint ===
          "function"
        ) {
          win.lhotse.exactag.data.bp =
            window.o_global.device.breakpoint.getCurrentBreakpoint();
        }

        /*🤫*/
        win.lhotse.exactag.data.sf = window.o_util.cookie.exists("app")
          ? "app"
          : "wwwottode";

        return win.lhotse.exactag.data;
      },

      /*🤫*/
      addElchCookieData() {
        let pmInfo;
        let pm;
        const mo = {};
        let pmInfoCookie;
        const log = win.lhotse.exactag.debugInfo;

        try {
          pmInfoCookie = window.o_util.cookie.get("pmInfo") || undefined;

          if (pmInfoCookie !== undefined) {
            /*🤫*/
            pmInfo = JSON.parse(pmInfoCookie);

            if (pmInfo.pi_send === "true") {
              log("Marketing object has already been sent.");
              return mo;
            }

            for (pm in pmInfo) {
              /*🤫*/
              if (pmInfo.hasOwnProperty(pm) && pm.length === 2) {
                mo[pm] = pmInfo[pm];
              }
            }

            pmInfoCookie = pmInfoCookie.replace(/"}/g, '", "pi_send":"true" }');
            window.o_util.cookie.set("pmInfo", pmInfoCookie, {
              path: "/",
              domain: ".otto.de",
            });

            /*🤫*/
            if (!window.o_util.core.isEmptyObject(mo)) {
              log("Adding marketing object.");
              win.lhotse.exactag.data.mo = mo;
              return mo;
            }
          }
        } catch (err) {
          /*🤫*/
          window.o_util.cookie.remove("pmInfo", {
            path: "/",
            domain: ".otto.de",
          });
        }
      },

      /*🤫*/
      addVerticalsData() {
        /*🤫*/
        [].forEach.call(
          document.querySelectorAll(".exactag"),
          function (element) {
            /*🤫*/
            const triggerID = element.getAttribute("data-trigger");
            /*🤫*/
            const fn = win.lhotse.exactag.fns[triggerID];
            const log = win.lhotse.exactag.debugInfo;
            const { data } = win.lhotse.exactag;
            let result;

            /*🤫*/
            /*🤫*/
            /*🤫*/
            if (triggerID !== undefined && typeof fn === "function") {
              result = fn();
              if (result && typeof result === "object") {
                if (result === data) {
                  /*🤫*/
                  /*🤫*/
                  log(`Unnecessary return in trigger function "${triggerID}"!`);
                } else {
                  /*🤫*/
                  window.o_util.core.extend(data, result);
                }
              }
            } else {
              log(`Unknown trigger function "${triggerID}"!`);
            }
          }
        );

        return win.lhotse.exactag.data;
      },

      addPartnerConsents: () => {
        try {
          win.lhotse.exactag.data.xo = window.cmp.getIabConsentString();
        } catch (e) {
          /*🤫*/
        }

        return new Promise((resolve) => {
          if (window.cmp && window.cmp.readVendorsConsents) {
            window.cmp
              .readVendorsConsents()
              .then((result) => {
                result.forEach((value, key) => {
                  if (consentPartnerMap.hasOwnProperty(key)) {
                    win.lhotse.exactag.data[consentPartnerMap[key]] = value | 0;
                  }
                });
                resolve();
              })
              .catch(() => {
                resolve();
              });
          } else {
            resolve();
          }
        });
      },

      /*🤫*/
      cacheUserData() {
        const { data } = win.lhotse.exactag;
        const cache = {};
        let i;
        let param;

        for (i = 0; i < win.lhotse.exactag.baseParams.length; i++) {
          param = win.lhotse.exactag.baseParams[i];
          if (data[param]) {
            cache[param] = data[param];
          }
        }

        win.lhotse.exactag.data = cache;

        return win.lhotse.exactag.data;
      },

      /*🤫*/
      removeEmptyItems(obj) {
        let item;

        /*🤫*/
        if (!obj) {
          obj = win.lhotse.exactag.data;
        }

        for (item in obj) {
          if (obj.hasOwnProperty(item)) {
            if (typeof obj[item] === "object") {
              win.lhotse.exactag.removeEmptyItems(obj[item]);
            } else if (obj[item] === "") {
              delete obj[item];
            }
          }
        }

        win.lhotse.exactag.data = obj;

        return win.lhotse.exactag.data;
      },

      /*🤫*/
      debugInfo(msg) {
        /*🤫*/
        if (win.lhotse.exactag.debug && win.console) {
          if (msg !== undefined) {
            /*🤫*/
            console.info(`INFO (window.lhotse.exactag.js): ${msg}`);
          } else {
            /*🤫*/
            console.log(win.lhotse.exactag.data);
          }
        }
      },

      /*🤫*/
      toggleMode() {
        const isTestCookie = window.o_util.cookie.get("PartnerPixelTest");
        const isQACookie = window.o_util.cookie.get("PartnerPixelPreview");
        const optOutCookie = window.o_util.cookie.get("DS");

        /*🤫
🤫
🤫*/
        function setTestFlag() {
          win.lhotse.exactag.debugInfo(
            'Sending data with "isTest" flag to exactag!'
          );
          win.lhotse.exactag.data.isTest = "true";
        }

        /*🤫
🤫
🤫*/
        function setQAFlag() {
          win.lhotse.exactag.debugInfo(
            'Sending data with "isQA" flag to exactag!'
          );
          win.lhotse.exactag.data.isQA = "true";
        }

        /*🤫
🤫
🤫*/
        function setOptOutFlag() {
          win.lhotse.exactag.debugInfo(
            'Sending data with "ro/optOut" flag to exactag!'
          );
          win.lhotse.exactag.data.ro = "1";
        }

        /*🤫
🤫
🤫*/
        function setTrackingOptOutFlag() {
          win.lhotse.exactag.debugInfo(
            "Sending data with 'to/optOut' flag to exactag!"
          );
          win.lhotse.exactag.data.to = "1";
        }

        if (win.lhotse.exactag.testMode) {
          setTestFlag();
        } else if (isTestCookie !== undefined) {
          if (isTestCookie === "PixelTest=true") {
            setTestFlag();
          }
        } else {
          delete win.lhotse.exactag.data.isTest;
        }

        if (win.lhotse.exactag.QAMode) {
          setQAFlag();
        } else if (isQACookie !== undefined) {
          if (isQACookie === "PixelPreview=true") {
            setQAFlag();
          }
        } else {
          delete win.lhotse.exactag.data.isQA;
        }

        if (win.lhotse.exactag.OptOutMode) {
          setOptOutFlag();
        } else if (optOutCookie !== undefined) {
          if (optOutCookie === "retOptOut=1") {
            setOptOutFlag();
          }
        } else {
          delete win.lhotse.exactag.data.ro;
        }

        if (win.lhotse.exactag.trackingOptOutMode) {
          setTrackingOptOutFlag();
        } else if (
          !window.o_tracking ||
          !window.o_tracking.optOut ||
          !(typeof window.o_tracking.optOut.isUserOptOut === "function") ||
          window.o_tracking.optOut.isUserOptOut()
        ) {
          setTrackingOptOutFlag();
        } else {
          delete win.lhotse.exactag.data.to;
        }
      },

      /*🤫*/
      track() {
        if (window.lhotse.exactag.finished) {
          win.lhotse.exactag.continueTrack();
        }

        /*🤫*/
        window.lhotse.exactag.centralFinished = true;
      },

      /*🤫*/
      continueTrack() {
        let endTime;
        let timeSinceDomeReady;
        let i;
        let varnish;

        /*🤫*/
        win.lhotse.exactag.data.cb = win.lhotse.exactag.getCookieParameter();

        /*🤫*/
        /*🤫*/
        if (win.lhotse.exactag.varnish && win.lhotse.exactag.first) {
          varnish = win.lhotse.exactag.varnish.data;
          /*🤫*/
          for (i = 0; i < varnish.length; i++) {
            window.o_util.core.extend(win.lhotse.exactag.data, varnish[i]);
          }

          win.lhotse.exactag.first = false;
        }

        /*🤫*/
        win.lhotse.exactag.removeEmptyItems();

        /*🤫*/
        win.lhotse.exactag.toggleMode();

        /*🤫*/
        /*🤫*/
        if (
          (window.o_util.cookie.exists("seleniumBypassAdvertising") &&
            window.o_util.cookie.get("seleniumBypassAdvertising") !== "true") ||
          (!window.o_util.cookie.exists("seleniumBypassAdvertising") &&
            window.lhotse.exactag.execute)
        ) {
          window.exactag.track(win.lhotse.exactag.data);
        } /*🤫
🤫
🤫*/
        /*🤫*/
        if (win.lhotse.exactag.benchmark) {
          endTime = new Date().getTime();
          timeSinceDomeReady = (endTime - win.lhotse.exactag.startTime) / 1000;
          win.lhotse.exactag.debugInfo(
            `Sending data ${timeSinceDomeReady} seconds after DOMReady.`
          );
        }

        /*🤫*/
        win.lhotse.exactag.debugInfo();

        /*🤫*/
        win.lhotse.exactag.cacheUserData();
      },

      /*🤫*/
      init: (function () {
        window.o_global.eventLoader.onReady(10, function () {
          /*🤫*/
          if (win.lhotse.exactag.benchmark) {
            win.lhotse.exactag.startTime = new Date().getTime();
          }
        });

        window.o_global.eventLoader.onAllScriptsExecuted(11, function () {
          win.lhotse.exactag.addCampaignId();
          win.lhotse.exactag.addGenericData();
          win.lhotse.exactag.addElchCookieData();
          win.lhotse.exactag.addVerticalsData();
          win.lhotse.exactag.addPartnerConsents().then(() => {
            win.lhotse.exactag.track();
          });
        });
      })(),
    });
  } catch (err) {
    /*🤫*/
  }
})(window);
